type IsInlineMacroPresentationInput = {
	isEditing?: boolean;
	layout: unknown;
};

export const isInlineMacroPresentation = ({
	isEditing,
	layout,
}: IsInlineMacroPresentationInput): boolean =>
	layout === 'inline' || (layout === 'inline-bodied' && !isEditing);
